import { Add as AddIcon } from "@mui/icons-material";
import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  SelectChangeEvent,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import backArrow from "../../assets/icons/backArrow.svg";
import { CustomInput } from "../../global/components";
import CustomButton from "../../global/components/CustomButton/CustomButton";
import CustomDialog from "../../global/components/CustomDialog/CustomDialog";
import CustomLoader from "../../global/components/CustomLoader/CustomLoader";
import CustomSelect from "../../global/components/CustomSelect/CustomSelect";
import strings from "../../global/constants/StringConstants";
import {
  handleErrorMessage,
  isTruthy,
  openSuccessNotification,
} from "../../helpers/methods";
import history from "../../utils/history";
import { theme } from "../../utils/styles";
import contactUsDialogStyles from "../Shared/Dialogs/ContactUsDialog/ContactUsDialog.styles";
import addDataStyles from "./AddData.styles";
import {
  addReportData,
  fetchOtherList,
  fetchOtherValues,
  getReportData,
} from "./AddDataService";
import RichTextEditor from "./RichTextEditor";

const AddData = () => {
  const classes = addDataStyles;
  const dialogClasses = contactUsDialogStyles;

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { t } = useTranslation();
  const [isOther, setIsOther] = useState<boolean>(true);
  const [list2, setList2] = useState<string[]>([]);
  const [list3, setList3] = useState<string[]>([]);
  const [otherList, setOtherListMap] = useState<string[]>([]);
  const isEnglishInitialized = useRef(false);
  const isPolishInitialized = useRef(false);
  const [selectedHouse, setSelectedHouse] = useState("");
  const [showEditor, setShowEditor] = useState<boolean>(false);

  // Dialog states
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [dialogInputs, setDialogInputs] = useState({
    key: "",
    value: "",
  });
  const [error, setError] = useState({
    house: "",
    planet: "",
    key: "",
    value: "",
  });

  const houseMenu = [
    {
      value: "d1",
      content: "D1",
    },
    {
      value: "d2",
      content: "D2",
    },
    {
      value: "d3",
      content: "D3",
    },
    {
      value: "d4",
      content: "D4",
    },
    {
      value: "d7",
      content: "D7",
    },
    {
      value: "d9",
      content: "D9",
    },
    {
      value: "d10",
      content: "D10",
    },
    {
      value: "d12",
      content: "D12",
    },
    {
      value: "d16",
      content: "D16",
    },
    {
      value: "d20",
      content: "D20",
    },
    {
      value: "d24",
      content: "D24",
    },
    {
      value: "d27",
      content: "D27",
    },
    {
      value: "d30",
      content: "D30",
    },
    {
      value: "d40",
      content: "D40",
    },
    {
      value: "d45",
      content: "D45",
    },
    {
      value: "d60",
      content: "D60",
    },
  ];

  const planets = [
    "Ascendant",
    "Descendent",
    "Medium Coeli",
    "Imum Coeli",
    "Sun",
    "Moon",
    "Rahu",
    "Ketu",
    ...otherList,
    "Mercury",
    "Venus",
    "Mars",
    "Jupiter",
    "Saturn",
    "Uranus",
    "Neptune",
    "Pluto",
  ];

  const listMap: any = {
    nakshatra: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
    ],
    house_nakshatra: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
    ],
    house: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    sign: [
      "Aries",
      "Taurus",
      "Gemini",
      "Cancer",
      "Leo",
      "Virgo",
      "Libra",
      "Scorpio",
      "Sagittarius",
      "Capricorn",
      "Aquarius",
      "Pisces",
    ],
    nakshatra_lord: [
      "Ascendant",
      "Sun",
      "Moon",
      "Mercury",
      "Venus",
      "Mars",
      "Jupiter",
      "Saturn",
      "Uranus",
      "Neptune",
      "Pluto",
      "Rahu",
      "Ketu",
    ],
    pada: ["1", "2", "3", "4"],
    pada_lord: [
      "Ascendant",
      "Sun",
      "Moon",
      "Mercury",
      "Venus",
      "Mars",
      "Jupiter",
      "Saturn",
      "Uranus",
      "Neptune",
      "Pluto",
      "Rahu",
      "Ketu",
    ],
    pada_sign: [
      "Aries",
      "Taurus",
      "Gemini",
      "Cancer",
      "Leo",
      "Virgo",
      "Libra",
      "Scorpio",
      "Sagittarius",
      "Capricorn",
      "Aquarius",
      "Pisces",
    ],
    sign_lord: [
      "Ascendant",
      "Sun",
      "Moon",
      "Mercury",
      "Venus",
      "Mars",
      "Jupiter",
      "Saturn",
      "Uranus",
      "Neptune",
      "Pluto",
      "Rahu",
      "Ketu",
    ],
  };

  const nakshatra: any = {
    "1": "Ashwini",
    "2": "Bharani",
    "3": "Krittika",
    "4": "Rohini",
    "5": "Mrigashirsha",
    "6": "Ardra",
    "7": "Punarvasu",
    "8": "Pushya",
    "9": "Ashlesha",
    "10": "Magha",
    "11": "Poorva Phalguni",
    "12": "Uttara Phalguni",
    "13": "Hasta",
    "14": "Chitra",
    "15": "Swati",
    "16": "Vishakha",
    "17": "Anuradha",
    "18": "Jyeshtha",
    "19": "Moola",
    "20": "Purva Ashadha",
    "21": "Uttara Ashadha",
    "22": "Shravana",
    "23": "Dhanishta",
    "24": "Shatabhisha",
    "25": "Purva Bhadrapada",
    "26": "Uttara Bhadrapada",
    "27": "Revati",
  };

  useEffect(() => {
    getOtherList();
  }, []);

  const getOtherList = async () => {
    try {
      setIsLoading(true);
      const response = await fetchOtherList();
      setOtherListMap(response);
      setIsLoading(false);
    } catch (error: any) {
      setIsLoading(false);
      handleErrorMessage(error);
    }
  };

  const checkForPlanet = (event: any) => {
    if (event.target.name === "planet") {
      if (!otherList.includes(event.target.value)) {
        setIsOther(false);
        return false;
      } else {
        setIsOther(true);
        return true;
      }
    }
  };

  const [payload, setPayLoad] = useState<any>({
    planet: "",
    key: "",
    value: "",
  });
  const [content, setContent] = useState<any>({
    content_en: "",
    content_pl: "",
    planet: "",
  });

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const setOtherValues = async (name: string) => {
    try {
      setIsLoading(true);
      const response = await fetchOtherValues(name);
      setList3(response);
      setIsLoading(false);
    } catch (error: any) {
      setIsLoading(false);
      handleErrorMessage(error);
    }
  };

  const handleDropDownChange = (event: any) => {
    const other = checkForPlanet(event);
    if (event.target.name === "planet") {
      if (other) {
        setOtherValues(event.target.value);
      } else {
        setList3([]);
      }

      setList2(Object.keys(listMap));
    } else if (event.target.name === "key") {
      setList3(listMap[event.target.value]);
    }
    setPayLoad({
      ...payload,
      [event.target.name]: event.target.value,
      ...(event.target.name === "planet"
        ? { key: "" }
        : event.target.name === "key"
        ? { value: "" }
        : {}),
    });
    setError({
      ...error,
      [event.target.name]: "",
    });
  };

  const handleDialogOpen = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setDialogInputs({ key: "", value: "" });
  };

  const handleDialogInputChange = (event: any) => {
    const { name, value } = event.target;

    setDialogInputs((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDialogAdd = async () => {
    try {
      setIsLoading(true);
      await addReportData(
        {
          name: dialogInputs.key,
          value: dialogInputs.value,
        },
        true
      );
      setContent({
        content_en: "",
        content_pl: "",
        planet: "",
        name: "",
        value: "",
      });
      getOtherList();
      setIsLoading(false);
      handleDialogClose();
      openSuccessNotification("Key & value added successfully.");
    } catch (error: any) {
      setIsLoading(false);
      handleErrorMessage(error);
    }
  };

  const handleValidation = () => {
    let isValid = true;
    if (!isTruthy(payload.planet)) {
      setError((prev) => ({ ...prev, planet: "Please select a planet." }));
      isValid = false;
    }
    if (!isTruthy(selectedHouse) && !isOther) {
      setError((prev) => ({ ...prev, house: "Please select a house." }));
      isValid = false;
    }
    if (!isTruthy(payload.key) && !isOther) {
      setError((prev) => ({ ...prev, key: "Please select a key." }));
      isValid = false;
    }
    if (!isTruthy(payload.value)) {
      setError((prev) => ({ ...prev, value: "Please select a value." }));
      isValid = false;
    }
    return isValid;
  };

  const handleHouseChange = async (e: SelectChangeEvent<string>) => {
    const val = e.target.value;
    setSelectedHouse(val);
    setError({
      ...error,
      house: "",
    });
  };

  const getData = async () => {
    try {
      if (handleValidation()) {
        setIsLoading(true);
        const body = isOther
          ? {
              name: payload.planet,
              value: payload.value,
            }
          : {
              planet: payload.planet,
              [payload.key]: payload.value,
              d_value: selectedHouse,
              ...(payload.key === "nakshatra"
                ? { nakshatra_name: nakshatra[payload.value] }
                : {}),
            };
        const response = await getReportData(body, isOther);
        isEnglishInitialized.current = false;
        isPolishInitialized.current = false;
        if (response.data.content_en === null) response.data.content_en = "";
        if (response.data.content_pl === null) response.data.content_pl = "";
        setContent(response.data);
        setShowEditor(true);
      }
    } catch (error: any) {
      if (error.errorCode === 400) {
        setShowEditor(true);
      } else {
        handleErrorMessage(error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleContent = (contentValue: string, contentType: string) => {
    setContent({
      ...content,
      [contentType]: contentValue,
    });
  };

  const addData = async () => {
    try {
      setIsLoading(true);
      const body = isOther
        ? {
            name: payload.planet,
            value: payload.value,
            content_en: content.content_en,
            content_pl: content.content_pl,
          }
        : {
            ...content,
            [payload.key]: payload.value,
            d_value: selectedHouse,
            ...(payload.key === "nakshatra"
              ? { nakshatra_name: nakshatra[payload.value] }
              : {}),
          };

      const response = await addReportData(body, isOther);
      setIsLoading(false);
      setContent({
        content_en: "",
        content_pl: "",
        planet: "",
        name: "",
        value: "",
      });
      setShowEditor(false);
      openSuccessNotification("Data updated successfully.");
    } catch (error: any) {
      setIsLoading(false);
      handleErrorMessage(error);
    }
  };

  const getHeader = () => {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: { sm: "center", xs: "baseline" },
          width: "100%",
        }}
        pb={3}
      >
        <Box
          display={"flex"}
          alignItems={"center"}
          sx={{ cursor: "pointer", width: "fit-content" }}
          onClick={() => history.goBack()}
        >
          {isMobile ? (
            <img src={backArrow} height={"20px"} alt="Module not found..." />
          ) : (
            <img src={backArrow} height={"25px"} alt="Module not found..." />
          )}
        </Box>
        <Typography sx={classes.italicTypo}>{t("addData")}</Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CustomButton
            label={"Add Key & value"}
            type={strings.PRIMARY}
            onClick={handleDialogOpen}
            icon={<AddIcon />}
          />
        </Box>
      </Box>
    );
  };

  const dialogHeaderContent = () => (
    <Stack direction={"column"} alignItems={"center"} spacing={2} pt={5}>
      <Typography sx={dialogClasses.contactUsHeader} px={2}>
        Add Key & Value
      </Typography>
      <Divider
        sx={{
          border: "1px solid #222222",
          width: "50%",
          height: "0px",
        }}
      />
    </Stack>
  );

  const dialogBodyContent = () => (
    <Stack
      direction={"column"}
      alignItems={"center"}
      pb={5}
      spacing={2}
      sx={dialogClasses.dialogContent}
    >
      <Grid
        container
        spacing={{ sm: 2, xs: 0 }}
        rowGap={{ sm: 0, xs: 1 }}
        columnGap={{ sm: 0, xs: 1 }}
      >
        <Grid item xs={12}>
          <CustomInput
            label={"Key"}
            name="key"
            value={dialogInputs.key}
            onChange={handleDialogInputChange}
            placeHolder={"Enter Key"}
            autoComplete="off"
            customClasses={dialogClasses.textField}
            customNameFieldClasses={dialogClasses.nameField}
          />
        </Grid>
        <Grid item xs={12}>
          <CustomInput
            label={"Value"}
            name="value"
            value={dialogInputs.value}
            onChange={handleDialogInputChange}
            placeHolder={"Enter value"}
            autoComplete="off"
            customClasses={dialogClasses.textField}
            customNameFieldClasses={dialogClasses.nameField}
          />
        </Grid>
      </Grid>
      <Stack direction={"row"} spacing={2} mt={2}>
        <Button onClick={handleDialogClose} sx={classes.cancelBtn}>
          <Box sx={classes.cancelBtnBox}>
            <Typography className="btnText"> {t("cancel")}</Typography>
          </Box>
        </Button>
        <Button
          onClick={handleDialogAdd}
          sx={classes.logoutBtn}
          disabled={
            !isTruthy(dialogInputs.key) || !isTruthy(dialogInputs.value)
          }
        >
          <Typography className="btnText"> {t("add")}</Typography>
        </Button>
      </Stack>
    </Stack>
  );

  return (
    <Box sx={classes.mainContainer}>
      <Box sx={classes.mainBox}>
        <Box sx={classes.subBox}>
          <Box sx={classes.scrollStyle}>
            <Container maxWidth="xl" sx={{ px: 1 }}>
              <Box>
                {getHeader()}
                <Grid container justifyContent={"center"} mt={2} spacing={2}>
                  <Grid
                    item
                    xl={isOther ? 4 : 3}
                    lg={isOther ? 4 : 3}
                    md={isOther ? 4 : 3}
                    sm={12}
                    xs={12}
                  >
                    <CustomSelect
                      required
                      label={"Planets"}
                      placeHolder="Select Planet"
                      menuItems={planets.map((item) => ({
                        value: item,
                        content: item,
                      }))}
                      onChange={handleDropDownChange}
                      id={"palnet"}
                      name={"planet"}
                      value={payload.planet}
                      error={error.planet}
                    />
                  </Grid>
                  {!isOther && (
                    <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
                      <CustomSelect
                        required
                        label="Divisional Chart"
                        id="house"
                        name="house"
                        value={selectedHouse}
                        onChange={handleHouseChange}
                        menuItems={houseMenu}
                        error={error.house}
                      />
                    </Grid>
                  )}
                  {!isOther && (
                    <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
                      <CustomSelect
                        required
                        label={"key"}
                        placeHolder="Select Key"
                        menuItems={list2.map((item) => ({
                          value: item,
                          content: item,
                        }))}
                        onChange={handleDropDownChange}
                        id={"key"}
                        name={"key"}
                        value={payload.key}
                        error={error.key}
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xl={isOther ? 4 : 3}
                    lg={isOther ? 4 : 3}
                    md={isOther ? 4 : 3}
                    sm={12}
                    xs={12}
                  >
                    <CustomSelect
                      required
                      label={"value"}
                      placeHolder="Select Value"
                      menuItems={list3.map((item: any) =>
                        payload.key === "nakshatra" ||
                        payload.key === "house_nakshatra"
                          ? {
                              value: item,
                              content: isTruthy(nakshatra[item])
                                ? item + "." + nakshatra[item]
                                : item,
                            }
                          : {
                              value: item,
                              content: item,
                            }
                      )}
                      onChange={handleDropDownChange}
                      id={"value"}
                      name={"value"}
                      value={payload.value}
                      error={error.value}
                    />
                  </Grid>
                </Grid>

                <Box
                  width={"100%"}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box width={"fit-content"} mt={2}>
                    <CustomButton label={"Submit"} onClick={getData} />
                  </Box>
                </Box>
                {showEditor && (
                  <>
                    <Grid
                      container
                      spacing={1}
                      justifyContent={"center"}
                      mt={2}
                      p={2}
                    >
                      <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <RichTextEditor
                          content={content.content_en}
                          handleContent={handleContent}
                          contentType={"content_en"}
                          title={"English"}
                        />
                      </Grid>
                      <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <RichTextEditor
                          content={content.content_pl}
                          handleContent={handleContent}
                          contentType={"content_pl"}
                          title={"Polish"}
                        />
                      </Grid>
                    </Grid>
                    <Box
                      width={"100%"}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Box width={"fit-content"}>
                        <CustomButton label={"Add"} onClick={addData} />
                      </Box>
                    </Box>
                  </>
                )}
              </Box>
            </Container>
          </Box>
        </Box>
      </Box>

      <CustomDialog
        width="600px"
        isDialogOpen={dialogOpen}
        closable={true}
        closeButtonVisibility={true}
        handleDialogClose={handleDialogClose}
        dialogHeaderContent={dialogHeaderContent()}
        dialogBodyContent={dialogBodyContent()}
      />

      <CustomLoader isLoading={isLoading} />
    </Box>
  );
};

export default AddData;
